<script>
import { mapGetters } from 'vuex';
import { find } from 'lodash';
import LibelleDatesLivraison from '../../../components/libelle-dates-livraison';

export default {
  name: 'CardsListItemCommandeEnCours',
  components: {
    LibelleDatesLivraison
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({ ref: 'referentiel/referentiel' }),
    libelleModeCamion () {
      const mode = find(this.ref.modesCamion, { code: this.item.codeModeCamion });
      if (mode) {
        return mode.libelle + (mode.libelleOption ? ' (' + mode.libelleOption + ')' : '');
      } else {
        return '';
      }
    }
  },
  methods: {
    getStatutLigne (ligne) {
      switch (ligne.etape) {
        case 'ENREGISTREE':
          return 'En attente de validation';
        case 'SUPPRIMEE':
          return 'Supprimée';
        case 'ERREUR':
          return 'Erreur';
        case 'PREPAREE':
          return 'Préparée';
        case 'LIVREE':
          return 'Livrée';
        case 'VALORISEE':
          return 'Valorisée';
        case 'LOGISTIQUE':
          return 'Logistique';
        case 'FACTUREE':
          return 'Facturée';
        default:
          return ligne.etape;
      }
    }

  }
};
</script>
<template>
  <div class="list-item">
    <div class="list-item-content">
      <div>
        <strong>{{ item.libelleArticle }}</strong><sub class="num-article">{{ item.numArticle }}</sub>
      </div>
      <div
        v-if="!isMobile"
        class="no-wrap primary--text"
      >
        <div
          v-if="item.codeUniteArticle === 'T'"
          class="v-center"
        >
          <v-icon color="primary">
            mdi-weight
          </v-icon>
          {{ item.quantiteCommande | formatDecimal(3) }} t
        </div>
        <div v-else>
          {{ item.quantiteCommande }}
        </div>
      </div>
      <div
        v-if="!isMobile"
        class="actions-container"
      >
        <v-btn
          color="secondary"
          outlined
        >
          <span class="statut">{{ getStatutLigne(item) }}</span>
        </v-btn>
      </div>
    </div>
    <div class="suppl secondary--text">
      <div v-if="item.supplementations">
        <div
          v-for="(supp, index) in item.supplementations"
          :key="index"
        >
          {{ supp.libelleArticle }}
        </div>
      </div>
      <div v-if="item.mineraux">
        <div
          v-for="(mineral, index) in item.mineraux"
          :key="index"
        >
          {{ mineral.libelleArticle }} {{ mineral.quantiteCommande }} %
        </div>
      </div>
    </div>

    <div
      v-if="isMobile"
      class="no-wrap primary--text"
    >
      <div
        v-if="item.codeUniteArticle === 'T'"
        class="v-center-mobile"
      >
        <div>
          <v-icon color="primary">
            mdi-weight
          </v-icon>
          {{ item.quantiteCommande | formatDecimal(3) }} t
        </div>

        <div class="actions-container">
          <v-btn
            color="secondary"
            outlined
          >
            {{ item.etape || 'Inconu' }}
          </v-btn>
        </div>
      </div>
      <div v-else>
        {{ item.quantiteCommande }}
        <div class="actions-container">
          <v-btn
            color="secondary"
            outlined
          >
            {{ item.etape || 'Inconu' }}
          </v-btn>
        </div>
      </div>
    </div>

    <div class="stockage">
      <div v-if="item.numBatiment">
        Bâtiment {{ item.numBatiment }}
      </div>
      <div
        style="flex-wrap:wrap;"
        class="infos-lieu-container primary--text v-center"
      >
        <v-icon color="primary">
          mdi-home
        </v-icon>
        <span
          v-if="item.codeTypeSilo1"
          class="avoidwrap"
        >
          <RefValue
            :code="item.codeTypeSilo1"
            type="TYPE_SILO"
          />
        </span>
        <span
          v-if="item.codeTypeSilo2"
          class="avoidwrap"
        >
          <RefValue
            :code="item.codeTypeSilo2"
            type="TYPE_SILO"
          />
        </span>
        <span
          v-if="item.codeTypeSilo3"
          class="avoidwrap"
        >
          <RefValue
            :code="item.codeTypeSilo3"
            type="TYPE_SILO"
          />
        </span>
      </div>
    </div>
    <div class="livraison">
      <!-- <div>
        Mode Camion : {{ libelleModeCamion }}
      </div> -->
      <div style="font-size:0.9em;font-weight:bold;">
        <LibelleDatesLivraison
          :date-debut="item.datePrevueLivraison"
          :date-fin="item.finDatePrevueLivraison"
          :horaire-debut="item.matinApmidi"
          :horaire-fin="item.finMatinApmidi"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.v-center-mobile {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.list-item {
  padding: 0.5em 1em;
}
.list-item-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  & > *:first-child {
    flex-grow: 1;
  }
  & > *:not(:first-child) {
    margin-left: 1em;
  }
}

.infos-lieu-container {
  span {
    margin-right: 0.58em;
    vertical-align: sub;
  }
}

.infos {
  font-style: italic;
  font-size: 0.9em;
}

.statut {
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
}
</style>
